import { faPerson, faQuestionCircle } from "@fortawesome/free-solid-svg-icons";
import FormComponents from "components/forms/FormComponents";
import { APIEndpoint, APIStatus, InputType, Modal } from "enums";
import log from "logger";
import manager from "managers/app";
import sysMsg from "managers/sysMsg";
import { GetCharacterAvatar } from "managers/types/net-types";
import { AddCharacterModalProps } from "modals/content/add-character/types";
import ModalContent from "modals/content/ModalContent";
import ModalFooter from "modals/footer/ModalFooter";
import ModalHeader from "modals/header/ModalHeader";
import { Component } from "react";
import { connect } from "react-redux";
import { OutputString } from "translations/types";
import { AppState } from "types/app";
import "./AddCharacterModal.css";

const mapStateToProps = (state:AppState):AddCharacterModalProps.Redux => {
	return {
		lang: state.userInfo.options.lang,
		gameLang: state.userInfo.options.gameLang,
		addCharacter: state.modal[Modal.ADD_CHARACTER],
	};
};

class AddCharacterModal extends Component<AddCharacterModalProps.Component> {
	render():JSX.Element{
		return (
			<div id={Modal.ADD_CHARACTER} className="modal-wrapper">
				<ModalHeader text="Add Character" icon={faPerson} />
				<ModalContent>
					<FormComponents.Form fieldDirection="column">
						<FormComponents.TextInput
							label={{ hide: false, text: "Lodestone / Character ID", position: "left", alignment: "center" }}
							input={{
								type: InputType.TEXT, value: "", id: "modal-character-id",
								showPopover: true, popoverId: "character-id-manual", popoverIcon: faQuestionCircle, popoverContent: this.props.addCharacter.popoverContent,
							}}
						/>
						<FormComponents.TextInput
							label={{ hide: false, text: "Character Name", position: "left", alignment: "center" }}
							input={{ type: InputType.TEXT, value: "", id: "modal-character-name", showPopover: true, popoverHidden: true, popoverId: "character-name-manual", popoverIcon: faQuestionCircle }}
						/>
					</FormComponents.Form>
				</ModalContent>
				<ModalFooter>
					<FormComponents.Button text="Close" onClick={manager.modal.close} translate={true} />
					<FormComponents.Button text="Add Character" onClick={this.addCharacter} translate={true} />
				</ModalFooter>
			</div>
		);
	}

	addCharacter = async():Promise<void> => { // Event
		const characterIdEle = document.getElementById("modal-character-id") as HTMLInputElement | null;
		const characterNameEle = document.getElementById("modal-character-name") as HTMLInputElement | null;
		const characterId = characterIdEle?.value;
		const characterName = characterNameEle?.value;

		if(!characterId){
			log.warn("Unable to find Character ID input value");
			sysMsg.error({ message: "Error retrieving the given Character ID" });
			return;
		}

		if(!characterName){
			log.warn("Unable to find Character Name input value");
			sysMsg.error({ message: "Error retrieving the given Character Name" });
			return;
		}

		const newCharacter = manager.data.getDefaultCharacter();
		newCharacter.seId = characterId;
		newCharacter.name = characterName;
		newCharacter.displayName = characterName;

		const avatarResult = await manager.request.send<GetCharacterAvatar.Request, GetCharacterAvatar.Response>(APIEndpoint.GET_AVATAR, { id: newCharacter.seId });

		if(!avatarResult || avatarResult.status !== APIStatus.SUCCESS){
			sysMsg.warn({ title: "Error processing request", message: avatarResult ? avatarResult.message as OutputString : "Error looking up avatar for character" as OutputString });
		}else{
			newCharacter.avatar = avatarResult.data.avatar;
		}

		const result = await manager.data.saveCharacters([newCharacter], true);

		if(result){
			manager.modal.close();
		}
	}
}
export default connect(mapStateToProps)(AddCharacterModal);
